import gql from 'graphql-tag';

export default gql`
    mutation configure($input: ConfigureInput) {
        configure(input: $input) {
            errors
        }
    }
`;
